var render = function render(){var _vm=this,_c=_vm._self._c;return _c('didi-minimal-layout',[_c('div',{staticClass:"fullscreen"},[_c('div',[(_vm.activeSlide === 0)?_c('ScreensaverLogo',{attrs:{"screensaverOpacity":_vm.screensaverOpacity}}):_vm._e(),(_vm.activeSlide === 1)?_c('ScreensaverNextParty',{attrs:{"screensaverOpacity":_vm.screensaverOpacity}}):_vm._e(),(_vm.activeSlide === 2)?_c('ScreensaverNextFlyer',{attrs:{"screensaverOpacity":_vm.screensaverOpacity}}):_vm._e()],1),_c('div',{staticClass:"cycle-indicator",style:({
      width: `${_vm.cycleCount/_vm.cyclesUntilReload * 100}%`,
    })}),_c('div',{staticClass:"cycle-indicator",style:({
      transition: `width ${_vm.screensaverOpacity ? _vm.slideDuration : 0}ms linear`,
      width: `${_vm.screensaverOpacity * 100}%`,
    })})])])
}
var staticRenderFns = []

export { render, staticRenderFns }